import * as React from "react";
import { Props } from "../../types/common";
import "./styles.scss";

const Headline = (props: Props): JSX.Element => {
    return <h2 className="headline">{props.children}</h2>;
};

export default Headline;
